module.exports = __webpack_public_path__ + "static/3.3_table_mobile-9d29484ed7914215908e9a721b3f0595.png";